import React from "react";

import Label from "@busbud/design-system-components/dist/Label";
import type {
  Orientation,
  SeatBaseState
} from "@busbud/design-system-components/dist/SeatBase";
import SeatBase from "@busbud/design-system-components/dist/SeatBase";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useAppContext } from "@app/helpers/hooks";
import type { TranslatorService } from "@app/services/translator";

import { useStyles } from "./seat-legend.styles";

type Props = {
  orientation?: Orientation;
  className?: string;
  spacing?: number;
  gendered?: boolean;
};

const getLegendItems = (
  translator: TranslatorService,
  gendered: boolean
): { state: SeatBaseState; text: string }[] => {
  if (gendered) {
    return [
      { state: "available", text: translator.t("!seat-legend.available") },
      {
        state: "unavailableWoman",
        text: translator.t("!seat-legend.taken-woman")
      },
      { state: "unavailableMan", text: translator.t("!seat-legend.taken-man") }
    ];
  }

  return [
    {
      state: "available",
      text: translator.t("!checkout.seat-selection.available-seat")
    },
    {
      state: "unavailable",
      text: translator.t("!checkout.seat-selection.occupied-seat")
    }
  ];
};

export const SeatLegend: React.FC<Props> = ({
  className,
  orientation = "top",
  spacing = 0,
  gendered = false
}) => {
  const { translator } = useAppContext();
  const { classes } = useStyles();

  return (
    <Stack
      className={className}
      justifyContent="space-around"
      alignItems="center"
      spacing={spacing}
    >
      {getLegendItems(translator, gendered).map((legend_item, index) => (
        <Stack key={index} alignItems="center">
          <SeatBase
            size="sm"
            state={legend_item.state}
            orientation={orientation}
          />
          <Label
            noWrap
            size="sm"
            fontWeight="bold"
            color="text.secondary.opaque"
            className={classes.legend}
          >
            {legend_item.text}
          </Label>
        </Stack>
      ))}
    </Stack>
  );
};
